export const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: 400,
    width: 'fit-content',
    height: 'fit-content',
    maxHeight: '95vh',
    overflowY: 'auto',
    bgcolor: 'background.paper',
    borderRadius: '0.25rem',
    boxShadow: 24,
    border: 0,
    outline: 0,
    p: 5,
}